import { render, staticRenderFns } from "./HelloSign.vue?vue&type=template&id=4bf04a47&"
import script from "./HelloSign.vue?vue&type=script&lang=js&"
export * from "./HelloSign.vue?vue&type=script&lang=js&"
import style0 from "./HelloSign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports